import { deleteRequest } from '..';

const deleteRole = (roleId: string) => deleteRequest(`users/roles/${roleId}`, { roleId });

export default deleteRole;
